module.exports = __webpack_public_path__ + "static/media/tutoriales_descarga.84fdfd20.svg";